module.exports = __webpack_public_path__ + "static/media/sample.27002f5f.jpg";